import { useAction, useAtom } from "@reatom/npm-react";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { filtersModalAtom } from "src/store/atoms";

import { FiltersModal, FiltersSheet } from "./components";

export const ResponsiveFiltersWidget = () => {
  const { isMobile } = useGravityDevice();

  const [filtersModalIsOpen] = useAtom(filtersModalAtom);
  const toggleFiltersModal = useAction(filtersModalAtom.toggle);

  if (isMobile) {
    return (
      <FiltersSheet open={filtersModalIsOpen} onClose={toggleFiltersModal} />
    );
  }
  return (
    <FiltersModal open={filtersModalIsOpen} onClose={toggleFiltersModal} />
  );
};
